import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faRoute, faCircleCheck, faTriangleExclamation } from '@fortawesome/free-solid-svg-icons';

const API = process.env.REACT_APP_API_BASE_URL;
const auth = () => ({ headers: { Authorization: `Bearer ${localStorage.getItem('userData')}` } });

/* Student profile › Edit & teacher: the course the student starts with (or goes to next).
   Empty = not chosen: the teacher decides it with the student in class. */
const StartCourse = ({ studentId }) => {
  const [data, setData] = useState(null);
  const [value, setValue] = useState('');
  const [busy, setBusy] = useState(false);
  const [msg, setMsg] = useState(null);

  useEffect(() => {
    let alive = true;
    axios
      .get(`${API}/api/admin/studentprofile/startcourse/${studentId}`, auth())
      .then((res) => {
        if (!alive) return;
        setData(res.data);
        setValue(res.data.startModuleId ? String(res.data.startModuleId) : '');
      })
      .catch(() => alive && setData({ modules: [], ready: false, failed: true }));
    return () => {
      alive = false;
    };
  }, [studentId]);

  const save = async () => {
    setBusy(true);
    setMsg(null);
    try {
      await axios.put(`${API}/api/admin/studentprofile/startcourse/${studentId}`, { moduleId: value || null }, auth());
      setData((d) => ({ ...d, startModuleId: value ? Number(value) : null }));
      setMsg({ ok: true, text: value ? 'Saved. The student, the teacher and the classes show this course next.' : 'Saved: the teacher decides the course with the student.' });
    } catch (err) {
      setMsg({ ok: false, text: err.response?.data?.error || 'Couldn’t save.' });
    } finally {
      setBusy(false);
    }
  };

  if (!data) return null;
  const changed = String(value || '') !== String(data.startModuleId || '');

  return (
    <section className="rmaes-card rmaes-teacher">
      <h3>
        <FontAwesomeIcon icon={faRoute} /> Next course
      </h3>
      {!data.ready ? (
        <p className="rmaes-dim">Run StartCourse.sql on the server to choose the next course.</p>
      ) : (
        <>
          <div className="rmaes-teacher-row">
            <label className="rmaes-field rmaes-grow">
              <span>The course the student starts with, or goes to next (the teacher can also choose it in the class feedback)</span>
              <select value={value} onChange={(e) => { setValue(e.target.value); setMsg(null); }} disabled={busy}>
                <option value="">Not chosen: the teacher decides with the student</option>
                {data.modules.map((m) => (
                  <option key={m.id} value={m.id}>
                    {m.name}
                  </option>
                ))}
              </select>
              {data.interestedCourse && <small>Asked for at the free trial: {data.interestedCourse}</small>}
            </label>
            <button type="button" className="rmaes-btn" onClick={save} disabled={busy || !changed}>
              {busy ? 'Saving…' : 'Save course'}
            </button>
          </div>
          {msg && (
            <p className={`rmaes-msg ${msg.ok ? 'is-ok' : 'is-error'}`}>
              <FontAwesomeIcon icon={msg.ok ? faCircleCheck : faTriangleExclamation} /> {msg.text}
            </p>
          )}
        </>
      )}
    </section>
  );
};

export default StartCourse;
